import { Plugin, Context } from '@nuxt/types';
import { getInstance } from '../plugins/authWrapper';

let intervalId;
let currentTime;
let expireTime;
const bufferTime = 120;

const startSessionManagement = (context: Context): void => {
  intervalId = setInterval(() => {
    checkExpiry(context);
  }, 10000);
};

function setTimes() {
  currentTime = Math.floor(Date.now() / 1000);

  const storage = window.localStorage;
  const tokenKey = Object.keys(storage).filter(key =>
    /^@@auth0spajs@@/.test(key)
  )[0];
  expireTime = JSON.parse(storage.getItem(tokenKey)).expiresAt;
}

function checkExpiry(context: Context) {
  if (getInstance()) {
    setTimes();

    if (expireTime + bufferTime - currentTime < 0) {
      getInstance().logout({
        returnTo: window.location.origin
      });
    } else if (expireTime - currentTime <= bufferTime) {
      context.store.commit('components/session-management/setDialog', true);
      clearInterval(intervalId);
    }
  }
}

const sessionManager: Plugin = (context: Context, inject) => {
  inject('sessionManager', {
    startSessionManagement: () => startSessionManagement(context)
  });
  startSessionManagement(context);
};

export default sessionManager;
